"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LongPressButton = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = require("react");
const React = __importStar(require("react"));
const LongPressButton = (props) => {
    const [counter, setCounter] = react_1.useState(props.seconds);
    const [inProgress, setInProgress] = react_1.useState(false);
    const intervalRef = react_1.useRef(null);
    const { children, seconds, clickAction, longPress, color, size, className, childrenOnHold, type = 'button' } = props, rest = __rest(props, ["children", "seconds", "clickAction", "longPress", "color", "size", "className", "childrenOnHold", "type"]);
    const longPressButtonClasses = classnames_1.default({
        [className]: !!className,
        'btn-secondary': color === 'secondary-red',
        'in-progress': inProgress,
        'long-press-button': true,
        [`btn-${size}`]: true,
    });
    react_1.useEffect(() => {
        return () => stopCounter();
    }, []);
    react_1.useEffect(() => {
        if (counter === 0) {
            if (clickAction) {
                clickAction();
            }
            stopCounter();
        }
    }, [counter]);
    // @ts-ignore
    const startCounter = (e) => {
        if (e.button === 0) {
            setInProgress(true);
            if (intervalRef.current) {
                return;
            }
            intervalRef.current = setInterval(() => {
                setCounter((prevState) => {
                    if (prevState === 0) {
                        return prevState;
                    }
                    return prevState - 1;
                });
            }, 1000);
        }
    };
    const stopCounter = () => {
        setInProgress(false);
        setCounter(props.seconds);
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };
    return (React.createElement("button", Object.assign({ className: longPressButtonClasses }, rest, { type: type, onPointerDown: (e) => startCounter(e), onPointerLeave: stopCounter, onPointerUp: stopCounter, style: inProgress ?
            {
                transition: `all ${props.seconds}s linear`,
            } : undefined }), childrenOnHold && inProgress ? childrenOnHold : children));
};
exports.LongPressButton = LongPressButton;
//# sourceMappingURL=LongPressButton.js.map